import { render, staticRenderFns } from "./FooterOther.vue?vue&type=template&id=4508e2d5"
import script from "./FooterOther.vue?vue&type=script&lang=js"
export * from "./FooterOther.vue?vue&type=script&lang=js"
import style0 from "./FooterOther.vue?vue&type=style&index=0&id=4508e2d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports